// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bter","fullView":"styles_fullView__17-U6"};